"use strict";
var __importDefault = this && this.__importDefault || function (e) { return e && e.__esModule ? e : { default: e } };
Object.defineProperty(exports, "__esModule", { value: !0 }), exports.UploadPanel = exports.setUploadFunc = void 0;
const react_1 = __importDefault(require("react")), 
      core_1 = require("@blueprintjs/core"), 
      image_1 = require("../utils/image"), 
      file_1 = require("../utils/file"), 
      images_grid_1 = require("./images-grid"), 
      l10n_1 = require("../utils/l10n"), 
      image_2 = require("../utils/image");

let uploadFunc = async e => (0, file_1.localFileToURL)(e);
function setUploadFunc(e) { uploadFunc = e }
exports.setUploadFunc = setUploadFunc;

let filesCache = [];
const UploadPanel = ({ store: e }) => {
  const [t, i] = react_1.default.useState(filesCache),
        [a, l] = react_1.default.useState(!1);

  return react_1.default.useEffect(() => { filesCache = t }, [t]), 
    react_1.default.createElement("div", { style: { height: "100%", display: "flex", flexDirection: "column" } }, 
      react_1.default.createElement("div", { style: { height: "45px", paddingTop: "5px" } }, (0, l10n_1.t)("sidePanel.uploadTip")), 
      react_1.default.createElement("div", { style: { marginBottom: "20px" } }, 
        react_1.default.createElement("label", { htmlFor: "input-file" }, 
          react_1.default.createElement(core_1.Button, { icon: "upload", style: { width: "100%" }, onClick: () => { 
            var e; 
            null === (e = document.querySelector("#input-file")) || void 0 === e || e.click() 
          } }, (0, l10n_1.t)("sidePanel.uploadImage")), 
          react_1.default.createElement("input", { type: "file", id: "input-file", style: { display: "none" }, onChange: async e => {
            const { target: t } = e;
            const maxSizeMB = 2.5;
            const maxSizeBytes = maxSizeMB * 1024 * 1024;
            l(!0);
            for (const e of t.files) {
              if (e.size > maxSizeBytes) {
                alert(`L'immagine è troppo grande. La dimensione massima consentita è di ${maxSizeMB} MB.`);
                continue; // Salta questo file e passa al successivo
              }
              const t = await uploadFunc(e);
              i(e => e.concat([t]));
            }
            l(!1), t.value = null;
          }, multiple: !0 }))), 
      react_1.default.createElement(images_grid_1.ImagesGrid, { images: t, isLoading: a, getPreview: e => e, onSelect: async (t, i, a) => {
        var l;
        let { width: n, height: r } = await (0, image_1.getImageSize)(t);
        const o = t.indexOf("svg+xml") >= 0 || t.indexOf(".svg") >= 0 ? "svg" : "image";
        if (a && "svg" === a.type && a.contentEditable && "image" === o) return void a.set({ maskSrc: t });
        if (a && "image" === a.type && a.contentEditable && "image" == o) {
          const e = (0, image_2.getCrop)(a, { width: n, height: r });
          return void a.set(Object.assign({ src: t }, e))
        }
        const c = Math.min(e.width / n, e.height / r, 1);
        n *= c, r *= c;
        const s = ((null == i ? void 0 : i.x) || e.width / 2) - n / 2, 
              u = ((null == i ? void 0 : i.y) || e.height / 2) - r / 2;
        null === (l = e.activePage) || void 0 === l || l.addElement({ type: o, src: t, x: s, y: u, width: n, height: r })
      }
    })
  )
};
exports.UploadPanel = UploadPanel;
